import { ReactElement } from "react";
import { IFinanceProps } from "../../../../interfaces/props/IFinanceProps";
import { FinanceTableForm } from "./FinanceTableForm/FinanceTableForm";

export function Finance({ form }: IFinanceProps): ReactElement {
  return <FinanceTableForm form={form} />;
}
